<template>
  <div class="download width-responsiveness">
    <subheader title="Downloads" />
    <div class="download-page">
      <div class="download-page__card-container">
        <download-card
          v-for="card in cards"
          :key="card.id"
          :content="card"
          :show-version="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import DownloadCard from '@/components/Download/DownloadCard'

export default {
  name: 'Download',
  components: {
    'subheader': SubHeader,
    'download-card': DownloadCard
  },
  data () {
    return {
      cards: [{
        id: 1,
        subhead: 'Impressão',
        title: 'Windows',
        description: 'Sistema de impressão Álvaro de <br/>etiquetas para o sistema operacional <br/>Windows XP e versões superiores',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/printer-client-binaries-xp/Alvaro_windows_1_0_0.exe',
            idBtn: 'btnWinXPDownload'
          }
        ]
      }, {
        id: 2,
        subhead: 'Impressão',
        title: 'Instalador <br>Zebra',
        description: 'Driver para impressoras Zebra dos modelos, GC 420T, TLP 2844, ZD 220 e Honeywell PC42t',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/printer-client-binaries-instalador-zebra/Instalador Zebra.zip',
            idBtn: 'btnInstaladorZebraDownload'
          }
        ]
      }, {
        id: 3,
        subhead: 'Interface',
        title: 'Documento para <br>interface XML',
        description: 'Documento para geração do XML de <br/>integração com o AOL 2.0 pelo sistema <br/>do laboratório',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/documentacao-interface-xml/Manual_Tecnico-Interface_XML_AOL2.0.zip',
            idBtn: 'btnDocInterfaceXMLDownload'
          }
        ]
      }, {
        id: 4,
        subhead: 'Interface',
        title: 'Tabela de <br/>crítica',
        description: 'Documento contendo os exames, códigos <br/>e regras para a interface com o AOL 2.0',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/tabela-de-critica/Tabela_de_Critica.xlsx',
            idBtn: 'btnTabelaCriticaDownload'
          }
        ]
      }, {
        id: 5,
        subhead: 'Interface',
        title: 'Arquivo de crítica <br>no formato XML',
        description: 'Arquivo XML contendo os códigos de <br/>exame e suas regras para a interface com <br/>o AOL 2.0',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/arquivo-de-critica-no-formato-xml/Interface__Arquivo_de_Critica.zip',
            idBtn: 'btnArqCriticaXMLDownload'
          }
        ]
      }, {
        id: 6,
        subhead: 'Webservice',
        title: 'Manual de Integração via Webservice',
        description: 'Documento contendo detalhes, instruções e exemplos do protocolo de integração via Etiqueta primária.',
        image: '/static/images/icon-downloads.svg',
        versionText: '9.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/documentacao-aolws/WebService_AOLWS.zip',
            idBtn: 'btnWebserviceDocumentationDownload'
          }
        ]
      }, {
        id: 7,
        subhead: 'Interface',
        title: 'Cartilha  <br/> Operacional',
        description: 'Baixe a cartilha que detalha todo nosso processo de envio de amostras.',
        image: '/static/images/icon-downloads.svg',
        versionText: '4.1',
        buttons: [
          {
            url: 'https://storageapoiob2bprd.blob.core.windows.net/aol-downloads/Alvaro-Apoio-Cartilha-Operacional.pdf',
            idBtn: 'btnArqCartilhaDownload'
          }
        ]
      }
      ],
      selectedCard: {}
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/variables';

  .download{

    .download-page {
      margin-top: $headerAndSubHeaderHeight;

      &__card-container {
        align-items: center;
        display: flex;
        height: 100%;
        flex-grow: 1;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: 0;
        padding: 0;

        .md-title {
          font-size: 24px;
          font-weight: 300;
          letter-spacing: -0.3px;
          text-align: left;
          color: #727272;
        }

        .card-version {
          margin-top: 10px;
          font-size: 18px;
          font-weight: 200;
          letter-spacing: -0.3px;
          color: #727272;
        }
      }
    }
}
</style>
